import Header2 from "common/header-2";
import MenuHeader from "features/menu/blocks/MenuHeader";
import { useFlag } from "hooks/useFlags";
import { useIsMobile } from "hooks/useIsMobile";
import React from "react";

const FRAME_BASE_URL = "https://bush-vision-88906545.figma.site/";

const MainPage: React.FC = () => {
  const { isMobile } = useIsMobile();
  const menuHeaderEnabled = useFlag("menuHeaderTest");

  return (
    <div className={isMobile ? "app-mobile" : "app"}>
      {menuHeaderEnabled ? <MenuHeader /> : <Header2 />}
      <iframe
        id="frame1"
        src={FRAME_BASE_URL}
        style={{ width: "100%", height: "calc(100vh - 60px)", border: "none" }}
        title="Пересоберём"
      />
    </div>
  );
};

export default MainPage;
